"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PadlockIcon = function PadlockIcon() {
  return _react2.default.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", width: "31", height: "31", fill: "none" },
    _react2.default.createElement("path", {
      fill: "#3F7FD3",
      fillRule: "evenodd",
      d: "M15.464 3.5a8 8 0 0 0-8 8V15h3v-3.5a5 5 0 1 1 10 0V15h3v-3.5a8 8 0 0 0-8-8Z",
      clipRule: "evenodd"
    }),
    _react2.default.createElement("path", {
      fill: "#ABC9FF",
      fillRule: "evenodd",
      d: "M23.964 27h-17a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h17a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-1.5 1.5Z",
      clipRule: "evenodd"
    }),
    _react2.default.createElement("path", {
      fill: "#C8DBFF",
      fillRule: "evenodd",
      d: "M15.464 27h-8.5a1.5 1.5 0 0 1-1.5-1.5v-11a1.5 1.5 0 0 1 1.5-1.5h8.5v14Z",
      clipRrule: "evenodd"
    }),
    _react2.default.createElement("path", {
      fill: "#8CB8FF",
      fillRule: "evenodd",
      d: "M6.964 25.5a1.5 1.5 0 0 1-1.5-1.5v1.5a1.5 1.5 0 0 0 1.5 1.5h17a1.5 1.5 0 0 0 1.5-1.5V24a1.5 1.5 0 0 1-1.5 1.5h-17Z",
      clipRule: "evenodd"
    }),
    _react2.default.createElement("path", {
      fill: "#5A94E1",
      fillRule: "evenodd",
      d: "M17.464 18a2 2 0 0 0-4 0c0 .746.413 1.389 1.019 1.733l-.52 2.767h3l-.518-2.767A1.991 1.991 0 0 0 17.464 18Z",
      clipRule: "evenodd"
    })
  );
};

exports.default = PadlockIcon;